// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'cfp',
          name: 'Call for Papers',
          component: () => import('@/views/cfp/Index.vue'),
        },
        {
          path: 'mc-cluskey',
          name: 'McCluskey',
          component: () => import('@/views/mc-cluskey/Index.vue'),
        },
        {
          path: 'submissions',
          name: 'Submissions',
          component: () => import('@/views/submissions/Index.vue'),
        },
        {
          path: 'venue',
          name: 'Venue',
          component: () => import('@/views/venue/Index.vue'),
        },
        {
          path: 'committee',
          name: 'Committees',
          component: () => import('@/views/committee/Index.vue'),
        },
        {
          path: 'sponsors',
          name: 'Sponsors',
          component: () => import('@/views/sponsors/Index.vue'),
        },
        /*
        {
          path: 'registration',
          name: 'Registration',
          component: () => import('@/views/registration/Index.vue'),
        },
        {
          path: 'mc-cluskey',
          name: 'McCluskey',
          component: () => import('@/views/mc-cluskey/Index.vue'),
        },
        {
          path: 'submissions',
          name: 'Submissions',
          component: () => import('@/views/submissions/Index.vue'),
        },
        {
          path: 'program',
          name: 'Program',
          component: () => import('@/views/program/Index.vue'),
        },
        {
          path: 'program/keynotes',
          name: 'Keynotes',
          component: () => import('@/views/keynotes/Index.vue'),
        },
        {
          path: 'program/invited',
          name: 'Invited',
          component: () => import('@/views/invited/Index.vue'),
        },
        {
          path: 'program/visionary',
          name: 'Visionary',
          component: () => import('@/views/visionary/Index.vue'),
        },
        {
          path: 'program/tutorials',
          name: 'Tutorials',
          component: () => import('@/views/tutorials/Index.vue'),
        },
        {
          path: 'proceedings',
          name: 'Proceedings',
          component: () => import('@/views/proceedings/Index.vue'),
        },
        */
      ],
    },

  ],
})

export default router
